import { useState } from "react";
import { Button, Dialog, DialogContent, DialogTrigger, Textarea } from "@/components/ui";
import { DialogBody, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ToolCallSummary } from "@/types/call";
import { SuggestedMessage } from "@/types/chat";
import { useRegenerateAITextMutation } from "@/query/comms/chat";
interface RegenerateAITextModalProps {
  children: React.ReactNode;
  suggestion: ToolCallSummary | SuggestedMessage;
  setSuggestion: (suggestion: ToolCallSummary | SuggestedMessage) => void;
}
export default function RegenerateAITextModal({
  children,
  suggestion,
  setSuggestion
}: RegenerateAITextModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    mutateAsync: regenerateAIText
  } = useRegenerateAITextMutation();
  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const result = await regenerateAIText({
        feedback,
        suggestedMessageId: suggestion.id
      });
      if (result) {
        setSuggestion(result);
      }
      setIsOpen(false);
    } catch (error) {
      console.error("Failed to submit feedback:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>What is wrong with this response?</DialogTitle>
          <DialogDescription>
            Tell the AI how to improve this message. This will help it generate
            better responses in the future.
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <Textarea placeholder="Tell the AI how to improve this and future responses." value={feedback} onChange={e => setFeedback(e.target.value)} className="min-h-[100px]" />
        </DialogBody>
        <DialogFooter>
          <Button variant="primary" onClick={handleSubmit} disabled={!feedback.trim()} isLoading={isSubmitting}>
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
}